import styled from 'styled-components';

export const Container = styled.div<{ $open: boolean }>`
  padding: ${({ theme, $open }) =>
    `${$open ? theme.spacing(4) : 0} ${theme.spacing(6)}`};
  transition:
    padding-top 200ms,
    padding-bottom 200ms;
`;
